<template>
  <DossierDocumentCard
    title="Alvará / Licença de Funcionamento"
    :status-options="statusOptions"
    :multiple-status="true"
    :status-requires-validity="['possui_vigente', 'possui_provisorio']"
    :status-requires-upload="['possui_vigente', 'possui_provisorio']"
    :explainer-text="explainerText"
    :mode="mode"
    :not-applicable="false"
    :start-collapsed="startCollapsed"
    v-model="formData"
    save-endpoint="/rest-home/dossier/license"
    upload-endpoint="/rest-home/dossier/license/upload"
    @saved="onSaved"
    @error="onError"
  >
    <!-- Campos específicos: órgão emissor e número -->
    <template #fields-before>
      <div class="dossier-module__fields">
        <div class="dossier-module__field-group">
          <label class="dossier-module__label">Órgão emissor</label>
          <v-text-field
            v-if="!isViewMode"
            v-model="formData.issuing_body"
            dense
            outlined
            hide-details
            placeholder="Ex: Prefeitura Municipal de São Paulo"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.issuing_body || "—"
          }}</span>
        </div>

        <div
          class="dossier-module__field-group dossier-module__field-group--small"
        >
          <label class="dossier-module__label">Número do alvará</label>
          <v-text-field
            v-if="!isViewMode"
            v-model="formData.license_number"
            dense
            outlined
            hide-details
            placeholder="Número ou protocolo"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.license_number || "—"
          }}</span>
        </div>
      </div>
    </template>
  </DossierDocumentCard>
</template>

<script>
import DossierDocumentCard from "../dossier/DossierDocumentCard.vue";

const EXPLAINER_TEXT = `
  O Alvará de Funcionamento é o documento expedido pela Prefeitura Municipal
  que autoriza o funcionamento da ILPI no endereço cadastrado.<br><br>
  Deve ser renovado conforme a periodicidade exigida pelo município.
  Alguns municípios emitem Licença de Funcionamento com denominação diferente,
  mas com a mesma finalidade.<br><br>
  O Sistema Clin não valida o conteúdo do documento, apenas registra sua
  existência para fins de organização e apresentação à fiscalização.
`;

export default {
  name: "DossierLicense",
  components: { DossierDocumentCard },
  props: {
    mode: {
      type: String,
      default: "edit",
      validator: (v) => ["edit", "view"].includes(v),
    },
    initialData: { type: Object, default: () => ({}) },
    startCollapsed: { type: Boolean, default: false },
  },
  data() {
    return {
      explainerText: EXPLAINER_TEXT,
      statusOptions: [
        { value: "possui_vigente", label: "Possui alvará vigente" },
        { value: "possui_provisorio", label: "Possui alvará provisório" },
        { value: "em_elaboracao", label: "Em processo de renovação" },
        { value: "nao_possui", label: "Não possui (pendente)" },
      ],
      formData: {
        issuing_body: "",
        license_number: "",
        status: [],
        validity_date: null,
        file_url: null,
        file_name: null,
        observations: "",
        ...this.flattenInitialData(),
      },
    };
  },
  computed: {
    isViewMode() {
      return this.mode === "view";
    },
  },
  watch: {
    initialData: {
      deep: true,
      handler() {
        Object.assign(this.formData, this.flattenInitialData());
      },
    },
  },
  methods: {
    flattenInitialData() {
      const d = this.initialData || {};
      return {
        issuing_body: d.issuing_body || "",
        license_number: d.license_number || "",
        status: d.status || [],
        validity_date: d.validity_date || null,
        file_url: d.file_url || null,
        file_name: d.file_name || null,
        observations: d.observations || "",
      };
    },
    onSaved(data) {
      this.$emit("saved", { module: "license", data });
    },
    onError(errors) {
      this.$emit("error", { module: "license", errors });
    },
  },
};
</script>